// backoffice/onboarding/risk-profiles/172ea7ad-fa3d-4b8f-be25-96de31d01399/flagged-rules'
import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";
import { useParams } from "react-router-dom";

export const UpdateProfileRuleContext = createContext(null);

type Props = {
  children: ReactElement;
};

const UpdateProfileRuleProvider: FunctionComponent<Props> = ({ children }) => {
  const { id } = useParams();

  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.put(
        `backoffice/onboarding/risk-profiles/${id}/flagged-rules`,
        payload,
      );
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
    }),
    [mutateAsync, data, error, isPending],
  );
  return (
    <UpdateProfileRuleContext.Provider value={contextValue}>
      {children}
    </UpdateProfileRuleContext.Provider>
  );
};

export default UpdateProfileRuleProvider;
